<template>
<el-row  style="margin-top:4vh">
      <el-col :lg="18">
        <p class="doc">Archivos</p>
      </el-col>
      <el-col :lg="6">
        <el-button class="crear"  @click="back">Regresar</el-button>  
      </el-col>
    </el-row>
    <el-divider style="margin-top:0;background-color:#000D5A;"></el-divider>
    
    <el-form 
    :label-position="top"
    class="administro"
    :model="localData"
    :rules="rules"
    ref="localData"
    @submit.prevent="handleSubmit"
     >
      <el-form-item label="Título del archivo*">
        <el-input type="text" v-model="localData.titulo" placeholder="Títuo"></el-input>
      </el-form-item>
      <!--<el-form-item label="Descripción*">
        <el-input type="text" v-model="localData.descripcion" maxlength="150" show-word-limit placeholder="Descripción (máximo 150 caractéres)"></el-input>
      </el-form-item>
      -->
      <el-form-item label="Tipo*">
        <el-select v-model="localData.tipo" placeholder="Selecciona el tipo">
          <el-option selected="selected" disabled value="Tipo">Tipo</el-option>
          <el-option label="Link" value="Link"></el-option>
          <el-option label="Video" value="Video"></el-option>
          <el-option label="PDF" value="PDF"></el-option>
          <el-option label="Imagen" value="Imagen"> </el-option>
        </el-select>
      </el-form-item>
      
      <el-form-item v-if="localData.tipo === 'PDF' || localData.tipo === 'Imagen'" label="Adjuntar documento*">
            </el-form-item >
                <el-upload v-if="localData.tipo === 'PDF'"
                drag
                v-model="localData.file"
                  action="https://jsonplaceholder.typicode.com/posts/"

              class="upload-demo" accept=".pdf,.png" 
              :file-list="fileList"
              :on-change="findImage"
              >
               <div class="uploadiv">
                 <img src="@/assets/upload.png" alt="">
               </div>
               <div class="el-upload__text">Arrastra tu archivo aquí ó<u> selecciona un archivo de tu ordenador.</u></div>
                
                     
              </el-upload>
               <el-upload v-if="localData.tipo === 'Imagen'"
                drag
              class="upload-demo" 
              :on-change="findImage">
               <div class="uploadiv">
                 <img src="@/assets/upload.png" alt="">
               </div>
               <div class="el-upload__text">Arrastra tu archivo aquí ó<u> selecciona un archivo de tu ordenador.</u></div>
                <template #tip>
                </template>  
                     
              </el-upload>
      <el-form-item label="URL" prop="link" v-if="localData.tipo != 'PDF' && localData.tipo !='Imagen'">
        <el-input type="text" name="link" placeholder="URL" v-model="localData.link"></el-input>
      </el-form-item>
      
      <el-form-item >
        <input class="publish"
         type="submit" value="Publicar documento" @click="handleSubmit('localData',$event)"  >
      </el-form-item>
    </el-form>
  
</template>

<script>
export default {
  name: "form",
  props: {
    btnText: String,
    elemento: {}
  },
  data() {
    return {
      tipo: '',
      localData: this.elemento,
      fileList:[],
      rules:{
        link: [
          {required: true, message:'Porfavor ingresa un link', trigger:'blur'},
          {type: 'url', message:'Porfavaor ingresa un link válido', trigger:'blur'}
        ]
      }
    }
  },
  computed:{
    validateURL(){
      if(this.elemento.link){
        console.log(this.elemento.link)
        try {
          let URL = new URL(this.elemento.link)
          return true
       } catch (_) {
         return false
       }
      }
      return true
      }
  },
  methods: {
    findImage(file,fileList) {
      this.localData.file = file
      this.fileList= fileList
      },
    handleSubmit() {
      this.$refs['localData'].validate((valid) => {
          if (valid) {
            console.log(this.elemento+'forms')
            this.$emit('submitted', this.elemento)
            this.localData = {
              titulo: '',
              descripcion: '',
              link: '',
              file: '',
            }
          this.$emit('regreso')
          } else {
            console.log('error submit!!');
            return false;
          }
      });
    },
    back(){
      this.$emit('regreso')
      this.localData = {
        titulo: '',
        descripcion: '',
        link: '',
        file: '',
      }
    },

  }
}
</script>

<style lang="scss">
.doc{
  font-family: 'Poppins';
  font-weight: 800;
  font-size: 24px;
  float: left;
  line-height: 34px;
}
.crear{
  color: #000D5A;
  border: 2px solid #000D5A;
  background-color: transparent;
  margin-top: 0.8em;
  font-family: 'Avenir';
  font-size: 18px;
  border-radius: 15px;
  width: 225px;

}
.administro .el-form-item__label{
  font-size: 20px;
  font-family: 'Avenir';
  color: #000D5A;
  line-height: 27px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.administro .el-input__inner{
  background-color: #fff !important;
  color: #000 !important;
  border:2px solid #fff !important;
  font-size: 20px;
  height: 46px !important;
}
.administro .el-input__inner:focus{
  border: 2px solid #000D5A !important;
}
.administro .el-input__inner::placeholder{
  opacity: 50% !important;
  color: #000D5A !important;
}
.administro .el-upload-dragger{
  width: 66vw;
  border: 1px solid #fff;
  height: 90px;
  padding: 5px;
}
.uploadiv{
    background-color: #F4F5F7;
    float: left;
    height: 85%;
    width: 85px;
    padding-top: 1%;
    margin-left: 3%;
    border-radius: 15px;
}
.administro .el-select{
      float: left;
    margin-top: 35px;
    margin-left: -60px;
}
.administro .el-form-item{
  margin-bottom: 18px;
}
.administro .el-upload__text{
  font-size: 20px;
  color: #000D5A;
  font-family: 'Avenir';
  margin-top: 30px;
}

.publish{
  margin-top: 20px;
  background-color: #E27367;
  color:#fff;
  float: right;
  width: auto;
  height: 54px;
  font-size: 22px;
  font-family: 'Avenir';
  border-radius: 20px;
}

.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover
.fadeButton{
  opacity: .5 !important;
  background-color: #E27367  !important;
}
</style>